import { ProductPropertiesTypes } from '../BookingsCalendarTypes';

export const getOrderProperties = (allOrderProperties) => {
    if (allOrderProperties.length > 0) {
        return allOrderProperties.filter((property) => {
            return (
                property.value === ProductPropertiesTypes.Film ||
                property.value === ProductPropertiesTypes.Measured ||
                property.value === ProductPropertiesTypes.Matterport ||
                property.value === ProductPropertiesTypes.Drone
            );
        }).map((property) => {
            return property.value;
        });
    }
    return [];
};